/**
 * Instrumentação de performance dos fluxos críticos.
 *
 * Usa a User Timing API (`performance.mark` / `performance.measure`) para medir
 * a duração de fluxos sensíveis (login, pesquisa, detalhe do CNPJ). As medições
 * ficam disponíveis no Performance Timeline do navegador e em ferramentas de
 * APM.
 */

/** Indica se a API de performance está disponível no ambiente. */
const supported =
  typeof performance !== "undefined" &&
  typeof performance.mark === "function" &&
  typeof performance.measure === "function";

/** Marca o início de um fluxo. O nome da marca é `<flow>:start`. */
export function markStart(flow: string): void {
  if (supported) {
    performance.mark(`${flow}:start`);
  }
}

/**
 * Marca o fim de um fluxo e registra a medição entre o início e o fim. A
 * medição recebe o nome do fluxo; uma falha (ex.: marca de início ausente) é
 * silenciada — a instrumentação nunca derruba a aplicação.
 */
export function markEnd(flow: string): void {
  if (!supported) {
    return;
  }
  try {
    performance.mark(`${flow}:end`);
    performance.measure(flow, `${flow}:start`, `${flow}:end`);
  } catch {
    // Marca de início ausente — medição ignorada.
  }
}
